export default "__VITE_ASSET__CE5iUFon__"